import 'reflect-metadata';
import './vue-augmentations';
import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VuetifyConfirm from 'vuetify-confirm';
import { i18n } from './i18n';

function applyShellLocaleToI18n(lang: string | null | undefined): void {
  if (lang === 'en' || lang === 'de' || lang === 'ru' || lang === 'fr') {
    i18n.locale = lang;
  }
}

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.locale;
  window.addEventListener('rosi-lang-changed', (ev: Event) => {
    const d = (ev as CustomEvent<{ lang?: string }>).detail;
    applyShellLocaleToI18n(d && d.lang);
  });
  window.addEventListener('storage', (e: StorageEvent) => {
    if (e.key !== 'rosi.lang' || !e.newValue) return;
    applyShellLocaleToI18n(e.newValue);
  });
}

Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    onNextTickRerender: function(callback) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(callback);
        });
      });
    }
  },
  /**
   * Vue 2 + vue-i18n: templates using $t() may not re-render when locale changes because
   * dependency tracking does not always pick up i18n.locale. Re-render on locale change.
   */
  watch: {
    '$i18n.locale'() {
      this.$forceUpdate();
    }
  }
});

Vue.use(VuetifyConfirm, { vuetify });

new Vue({
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
